<script>
import { containerMenuProps, useContainerMenu } from "./menu.mixin";

export default {
  props: {
    ...containerMenuProps(),
    isMobile: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup() {
    const { categories } = useContainerMenu();
    return {
      categories
    };
  }
};
</script>

<template>
  <div class="u-none">
    <ul>
      <li
        v-for="category in categories"
        :key="`menu-seo-${category.id}`"
      >
        <a
          v-if="isMobile"
          :href="category.attributes.slug"
        >
          {{ category.attributes.libelle }}
        </a>
        <ul v-if="category.attributes.children">
          <li
            v-for="subcategory in category.attributes.children.data"
            :key="`menu-seo-current-${subcategory.id}`"
          >
            <a :href="subcategory.attributes.slug">
              {{ subcategory.attributes.libelle }}
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>
